import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { WeightTypesService } from 'src/services/data/weight-types.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createWeightType, createWeightTypeFailure, createWeightTypeSuccess, deleteWeightType, deleteWeightTypeFailure, deleteWeightTypeSuccess, loadWeightTypes, loadWeightTypesFailure, loadWeightTypesSuccess, updateWeightType, updateWeightTypeFailure, updateWeightTypeSuccess } from './weight-type.actions'

@Injectable()
export class WeightTypeEffects {
  private actions$ = inject(Actions)
  private WeightTypes = inject(WeightTypesService)
  private toaster = inject(ToasterService)


  loadWeightTypes$ = createEffect(() => this.actions$.pipe(
    ofType(loadWeightTypes),
    switchMap(() =>
      from(this.WeightTypes.getWeightTypes()).pipe(
        map(weightTypes => loadWeightTypesSuccess({ weightTypes })),
        catchAndLog(this.toaster, 'Unable to fetch weight types', loadWeightTypesFailure)))))

  createWeightType$ = createEffect(() => this.actions$.pipe(
    ofType(createWeightType),
    tap(() => this.toaster.progress('Creating weight type...')),
    switchMap(action =>
      from(this.WeightTypes.create(action.weightType)).pipe(
        map(weightType => createWeightTypeSuccess({ weightType })),
        tap(() => this.toaster.success('Weight type created successfully.')),
        catchAndLog(this.toaster, 'Unable to create weight type', createWeightTypeFailure)))))

  updateWeightType$ = createEffect(() => this.actions$.pipe(
    ofType(updateWeightType),
    tap(() => this.toaster.progress('Updating weight type...')),
    switchMap(action =>
      from(this.WeightTypes.update({ ...action.weightType, type_id: action.id })).pipe(
        map(weightType => updateWeightTypeSuccess({ weightType })),
        tap(() => this.toaster.success('Weight type updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update weight type', updateWeightTypeFailure)))))

  deleteWeightType$ = createEffect(() => this.actions$.pipe(
    ofType(deleteWeightType),
    tap(() => this.toaster.progress('Deleting weight type...')),
    switchMap(action =>
      from(this.WeightTypes.remove(action.id)).pipe(
        map(() => deleteWeightTypeSuccess({ id: action.id })),
        tap(() => this.toaster.success('Weight type deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete weight type', deleteWeightTypeFailure)))))
}
